import { createAction } from '@reduxjs/toolkit';
import { appSettingsActionTypes, AppSettingsConfig } from './models';

export const loadAppSettingsStart = createAction(appSettingsActionTypes.LOAD_APPSETTINGS_START);

export const loadAppSettingsSuccess = createAction(
  appSettingsActionTypes.LOAD_APPSETTINGS_SUCCESS,
  (appsettings: AppSettingsConfig) => ({
    payload: appsettings,
  })
);

export const loadAppSettingsFailure = createAction(
  appSettingsActionTypes.LOAD_APPSETTINGS_FAILURE,
  // TODO: Add and implement ErrMsg Interface
  (errMsg: string) => ({
    payload: errMsg,
  })
);